const URL={
    HOME_ORIGIN:"http://fellowapp.southeastasia.cloudapp.azure.com/testing/"
}
URL.SIGN_IN=URL.HOME_ORIGIN+"landingpageUsers.php";
URL.BOOK_NOW=URL.HOME_ORIGIN+"booknow.php";
URL.SUBMIT_QNA=URL.HOME_ORIGIN+"landingQna.php"

export default URL;